export default __webpack_public_path__ + "static/bg-hcuk-f3ce8e9bb2d5e3c8c99a229761a76aec.jpg";